import { assign } from 'lodash';
import createReducer from './baseReducer';

const conditions = {
  REQUEST_BANKING_EXPORTS: (state, data, error) =>
    assign({}, state, {
      isFetching: true,
    }),
  RECEIVE_BANKING_EXPORTS: (state, data, error) =>
    assign({}, state, {
      isFetching: false,
    }),
};

export default createReducer('payments', 'payment', 'payments', conditions);
